import { useNavigate } from "react-router-dom";

export default function PagoFallido() {

  const navigate = useNavigate();

  return (
    <div className="modal-backdrop">
      <div className="modal">

        <p>
          ❌ Pago no completado{"\n\n"}
          La operación fue cancelada o rechazada.
        </p>

        <div className="modal-actions">
          <button
            className="card-btn card-btn-primary glow-btn"
            onClick={() => navigate("/")}
          >
            Intentar nuevamente
          </button>
        </div>

      </div>
    </div>
  );
}